;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.inbox.show')
    .controller('InboxShowController', InboxShowController)

  InboxShowController.$inject = [
    // Angular
    '$injector', '$state', '$uibModal',
    '$q', '$filter',

    // Managers
    'QuoteManager', 'InvoiceManager', 'EntityManager',
    'ProductManager', 'TagManager', 'InvoiceLineManager',
    'QuoteLineManager', 'UserManager',

    // Services
    'PreferencesService', 'InvoiceService', 'LineService',
    'SelectionService', 'QuoteService', 'DatePickerService',
    'EntityService', 'ComputingService', 'ReferersService',

    // Resolve
    'inmail'

  ]

  function InboxShowController (
    // Angular
    $injector, $state, $uibModal,
    $q, $filter,

    // Managers
    QuoteManager, InvoiceManager, EntityManager,
    ProductManager, TagManager, InvoiceLineManager,
    QuoteLineManager, UserManager,

    // Services
    PreferencesService, InvoiceService, LineService,
    SelectionService, QuoteService, DatePickerService,
    EntityService, ComputingService, ReferersService,

    // Resolve
    inmail

  ) {
    var self = this

    var orderFields = [
      {
        path: 'ref',
        name: "Référence de l'affaire",
        enable: true,
        model: 'order',
        type: 'string'
      },
      {
        path: 'title',
        name: "Titre de l'affaire",
        enable: true,
        model: 'order',
        type: 'string'
      },
      {
        path: 'billingEntity.label',
        name: 'Client',
        enable: true,
        model: 'order',
        type: 'entity'
      },
      {
        path: 'memo',
        name: 'Memo',
        enable: true,
        model: 'order',
        type: 'string'
      },
      {
        path: 'description',
        name: "Description de l'affaire",
        enable: true,
        model: 'order',
        type: 'string'
      }
    ]

    self.$onInit = () => {
      _.extend(self, {
        // Attribute
        inmail: inmail,
        orderFields: orderFields,
        type: _.get(inmail, 'raw.__type', 'Invoice'),
        selection: SelectionService.getSelection(),
        // Methods
        editLine: editLine,
        removeLines: removeLines,
        validate: validate,
        selectEntity: selectEntity,
        deleteEntity: deleteEntity,
        addLine: addLine,
        removeLine: removeLine,
        addTitle: addTitle,
        editTitle: editTitle,
        setStartDate: setStartDate,
        resetStartDate: resetStartDate,
        setDueDate: setDueDate,
        resetDueDate: resetDueDate,
        getInvoiceDiscountedTotal: getInvoiceDiscountedTotal,
        getTotalDiscount: getTotalDiscount,
        containsDiscount: containsDiscount,
        getDiscountAmount: getDiscountAmount,
        getDiscountedTotal: getDiscountedTotal,
        getTotal: getTotal,
        getFullTotal: getFullTotal,
        selectReferers: selectReferers
      })

      init()
    }

    function init () {
      self.loading = true
      self.editable = true
      if (_.get(self.inmail.raw, 'billingEntity')) {
        self.inmail.raw.billingEntity = EntityManager.create(self.inmail.raw.billingEntity)
      }
      if (_.get(self.inmail.raw, 'shippingEntity')) {
        self.inmail.raw.shippingEntity = EntityManager.create(self.inmail.raw.shippingEntity)
      }
      if (_.get(self.inmail.raw, 'interventions[0].shippingEntity')) {
        self.inmail.raw.interventions[0].shippingEntity = EntityManager.create(self.inmail.raw.interventions[0].shippingEntity)
      }
      PreferencesService.getCompanyPrefs().then(function (prefs) {
        self.units = prefs.units
        self.vats = prefs.vats
      })
      initManagers()
      handleInmail(self.inmail).then(function (object) {
        self.object = object
        initObject()
        self.loading = false
      })
    }

    function initObject () {
      self.object.lines = self.object.lines || []
      self.object.referers = self.object.referers || []
      self.object.tags = self.object.tags || []
      getDiscounts()
      getVATs()
    }

    function selectReferers () {
      ReferersService.promptSelection(self.object.referers)
        .then(function (referers) {
          self.object.referers = referers
          self.theForm.$dirty = true
        })
    }

    function getTotalDiscount () {
      return ComputingService.getTotalDiscount(self.discounts)
    }

    function containsDiscount () {
      return ComputingService.containsDiscount(self.object)
    }

    function getDiscountAmount (line) {
      return ComputingService.getDiscountAmount(line)
    }

    function getDiscountedTotal (line) {
      return ComputingService.getDiscountedTotal(line)
    }

    function getDiscounts () {
      self.discounts = ComputingService.getDiscounts(self.object.lines)
    }

    /**
     * EX-VAT Total
     */
    function getTotal () {
      return ComputingService.getTotal(self.object.lines)
    }

    /**
     * Sets self.vats to a collection containing 'amount' and 'VAT'
     */
    function getVATs () {
      self.vats = ComputingService._getVATs(self.object.lines)
    }

    function getInvoiceDiscountedTotal () {
      return ComputingService.getObjectDiscountedTotal(self.object.lines)
    }

    function getFullTotal () {
      return ComputingService.getFullTotal(self.object.lines, self.vats)
    }

    function initManagers () {
      switch (self.type) {
        case 'Invoice':
        case 'invoice':
          self.manager = InvoiceManager
          self.lineManager = InvoiceLineManager
          self.service = InvoiceService
          break
        case 'Quote':
        case 'quote':
          self.manager = QuoteManager
          self.lineManager = InvoiceLineManager
          self.service = QuoteService
          break
      }
    }

    function selectEntity () {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual']
      }
      EntityService.prompt(config).then(function (entity) {
        self.object.client = entity
        self.theForm.$dirty = true
      })
    }

    function deleteEntity () {
      self.object.client = null
      self.theForm.$dirty = true
    }

    function removeLine (index) {
      self.object.lines.splice(index, 1)
      self.theForm.$dirty = true
      initObject()
    }

    function addLine () {
      return LineService.promptLineCreate(self.object)
        .then(function (res) {
          self.object.lines = self.object.lines || []
          if (res.category) {
            var i = _.findIndex(self.object.lines, { 'label': res.category.label })
            if (i >= 0) {
              self.object.lines.splice(i + 1, 0, res.line)
            } else {
              self.object.lines.push(res.category)
              self.object.lines.push(res.line)
            }
          } else {
            self.object.lines.unshift(res.line)
          }
          self.theForm.$dirty = true
          initObject()
        })
    }

    /* function editLine (index, action) {
      return LineService.promptLineEdit(self.object, self.object.lines[index].clone(), action)
        .then(function (res) {
          if (res.category) {
            var i = _.findIndex(self.object.lines, {'label': res.category.label})
            if (i >= 0) {
              if (index > i) {
                i++
              }
              self.object.lines[index] = res.line
              self.object.lines.splice(i, 0, self.object.lines.splice(index, 1)[0])
            } else {
              self.object.lines.splice(index, 1)
              self.object.lines.push(res.category)
              self.object.lines.push(res.line)
            }
          } else {
            self.object.lines[index] = res.line
          }
          self.theForm.$dirty = true
          init()
        })
    } */

    function addTitle () {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function () { return self.object },
          line: angular.noop,
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then((data) => {
              return data.map(category => category.label)
            })
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        self.object.lines = self.object.lines || []
        var i = _.findIndex(self.object.lines, { 'label': line.label })
        if (i < 0) {
          self.object.lines.push(line)
        }
        self.theForm.$dirty = true
        initObject()
      })
    }

    function editTitle (index) {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function () { return self.object },
          line: function () { return self.object.lines[index].clone() },
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then((data) => {
              return data.map(category => category.label)
            })
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        var i = _.findIndex(self.object.lines, { 'label': line.label })
        if (i >= 0) {
          self.object.lines.splice(index, 1)
        } else {
          self.object.lines[index] = line
        }
        self.theForm.$dirty = true
        initObject()
      })
    }

    function changeDueDate () {
      PreferencesService.getPrefsFor('invoice').then(function (prefs) {
        self.object.dueDate = moment(self.object.date).add(prefs.invoiceDelay, 'days').toDate()
        self.theForm.$dirty = true
      })
    }

    function setStartDate () {
      var opt
      if (self.object.dueDate) {
        opt = {
          maxDate: self.object.dueDate
        }
      }
      DatePickerService.getRange(self.object.date, opt).then(function (date) {
        self.object.date = new Date(date)
        self.theForm.$dirty = true
        changeDueDate()
      })
    }

    function resetStartDate () {
      self.object.date = null
      self.theForm.$dirty = true
    }

    function setDueDate () {
      var opt
      if (self.object.date) {
        opt = {
          minDate: self.object.date
        }
      }
      DatePickerService.getRange(self.object.dueDate, opt).then(function (date) {
        self.object.dueDate = new Date(date)
        self.theForm.$dirty = true
      })
    }

    function resetDueDate () {
      self.object.dueDate = null
      self.theForm.$dirty = true
    }

    function validate () {
      self.manager.create(self.object).save().then(function (data) {
        self.inmail.archive(data.data).then(function () {
          var route
          switch (self.type) {
            case 'Quote':
            case 'quote':
              route = 'quote.show'
              break
            case 'Invoice':
            case 'invoice':
              route = 'invoice.show'
              break
          }
          $state.go(route, { id: data.data._id })
        })
      })
    }

    function editLine ($index, action) {
      LineService.promptLineEdit(self.object, self.object.lines[$index], action, self.type).then(function (l) {
        // Map the resulting object to the existing one
        // To ensure we don't overwrite data added to display more info on the line (ie Solitech intervention info)
        Object.keys(l.line).forEach(function (key) {
          self.object.lines[$index][key] = l.line[key]
        })
        initObject()
      })
    }

    function removeLines (index) {
      self.object.lines.splice(index, 1)
    }

    function handleInmail (inmail) {
      switch (inmail.metadata.from) {
        /*         case 'SOLITECH':
          var promise
          switch (self.type) {
            case 'invoice':
            case 'Invoice':
              promise = InvoiceService.createInvoiceFromPreferences()
              break
            case 'quote':
            case 'Quote':
              promise = QuoteService.createQuoteFromPreferences()
          }
          return promise.then(function (object) {
            if (inmail.raw.billingEntity) object.client = inmail.raw.billingEntity
            object.title = inmail.raw.title
            object.reference = inmail.raw.ref
            if (typeof object.client === 'string') object.populate('client')
            if (_.get(inmail, 'raw.interventions.length') > 0) {
              self.interventions = inmail.raw.interventions
              self.interventionFields = _.filter(_.clone(defaultInterventionFields), function (field) {
                return _.some(self.interventions, function (inter) {
                  return !!_.get(inter, field.path)
                })
              })
            }
            return object
          }) */
      }
    }
  }
})(window.angular, window._, window.moment)
